import { useContext } from 'react';
import { Context, ContextValue } from './context';

export const useAuth = (): ContextValue => useContext(Context);
